import { render, staticRenderFns } from "./CalendarEventFooterResponseButtons.vue?vue&type=template&id=279a4df8&scoped=true&"
import script from "./CalendarEventFooterResponseButtons.vue?vue&type=script&lang=js&"
export * from "./CalendarEventFooterResponseButtons.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventFooterResponseButtons.vue?vue&type=style&index=0&id=279a4df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a4df8",
  null
  
)

export default component.exports